import type { FaireProductEntity } from "../../entity_types/product";

export const p_ugmg8evswd: FaireProductEntity = {
  token: "p_ugmg8evswd",
  type: "product",
  name: "Groomsman Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/6af96b83ad6fe3dd27ffc39b84618bf76dcd41655f72c4351c9f7db1cfdf3303.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d72b74b80536f2b8e813458991da3af843b9c27bac8b5c2607f63953fa070a13.jpeg",
    "https://cdn.faire.com/fastly/b69b5df0e4da56e41ce8cb1f19ce6f785bea7dc310205abf09a7feba4ec386f5.jpeg",
    "https://cdn.faire.com/fastly/3939c9867e98def82bdff61083c489236c52c57662dbda2375eed30b3a29605d.jpeg",
    "https://cdn.faire.com/fastly/5122ce898a4d84afaf2da56d3df9462207db8852807b0e8cff928c7ae0901830.jpeg",
    "https://cdn.faire.com/fastly/2e4a1fa42b9f264b445b19f0de276764893eaef6aba81257b511039d8dfb7735.jpeg"
  ],
  priceDollars: 6.75,
  description: "These socks are for the guy who survived the bachelor party, squeezed into a tux, lost a quiet battle against pit stains, and still brought his A-game to the dance floor. 🕺\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:36:31.474Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
